/* @flow weak */
import Checkbox from 'components/Checkbox.jsx';
import CheckboxCopy from 'components/CheckboxCopy.jsx';
import React from 'react';

import './styles/GroupOptionsForm.scss';

class GroupOptionsForm extends React.Component {
  static propTypes = {
    subscriberInitiatedChats: React.PropTypes.bool,
    hasChildren: React.PropTypes.bool,
    searchable: React.PropTypes.bool,
    showSearchable: React.PropTypes.bool,
    onChange: React.PropTypes.func,
    userIsTeacher: React.PropTypes.bool.isRequired,
    hideUnderageNote: React.PropTypes.bool,
  };

  static defaultProps = {
    subscriberInitiatedChats: true,
    hasChildren: true,
    searchable: true,
    showSearchable: false,
  };

  state = {
    subscriberInitiatedChats: this.props.subscriberInitiatedChats,
    hasChildren: this.props.hasChildren,
    searchable: this.props.searchable,
  };

  componentWillReceiveProps(nextProps) {
    this.setState({
      subscriberInitiatedChats: nextProps.subscriberInitiatedChats,
      hasChildren: nextProps.hasChildren,
      searchable: nextProps.searchable,
    });
  }

  getValues = () => {
    return {
      has_children: this.props.userIsTeacher && this.state.hasChildren,
      searchable: this.state.searchable,
      subscriber_initiated_chats: this.state.subscriberInitiatedChats,
    };
  };

  toggle = (name) => {
    this.setState({ [name]: !this.state[name] });

    if (this.props.onChange) {
      this.props.onChange(name, !this.state[name]);
    }
  };

  renderUnder13Checkbox = () => {
    const labelNote = `It’s okay if students are under 13. We’ll ask for a parent’s email address to
      keep everyone in the loop.`;

    return (
      <div>
        <Checkbox
          checked={!this.state.hasChildren}
          labelNote={labelNote}
          onChange={() => this.toggle('hasChildren')}>
          I will only message people 13 or older
        </Checkbox>

        {
          this.state.hasChildren &&
            <p>
              Students under 13 can’t reply.
            </p>
        }
      </div>
    );
  };

  renderSearchableCheckbox = () => {
    return (
      <div className="GroupOptionsForm-searchableToggle">
        <Checkbox
          checked={this.state.searchable}
          onChange={() => this.toggle('searchable')}>
          People in this class can see and message each other
        </Checkbox>
        <p>
          If you select this option, people at your school can also find your class.
        </p>
      </div>
    );
  };

  render() {
    return (
      <CheckboxCopy className="GroupOptionsForm">
        {this.props.showSearchable && this.renderSearchableCheckbox()}

        {
          (this.props.userIsTeacher && !this.props.hideUnderageNote) ?
            this.renderUnder13Checkbox() :
            <p>
              This class can only include people who are 13 or older.
            </p>
        }
      </CheckboxCopy>
    );
  }
}

export default GroupOptionsForm;



// WEBPACK FOOTER //
// ./src/groups/components/GroupOptionsForm.jsx